import * as React from "react";
import Translate from '../../../common/functions/translate';
import * as Constants from '../../../common/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faStethoscope, faPills, faPrescription, faMapMarkedAlt, faHeartbeat, faUsers, faVial } from '@fortawesome/free-solid-svg-icons';
import AuthService from '../../../services/authService';
import GraphQLService from '../../../services/graphqlService'
import { UserDashboardModel } from '../../../models/user/userDashboardModel'
import Spinner from '../../../common/components/spinner/spinner';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/actionTypes';
import Growl from '../../../common/components/alertMessage/growl';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';

interface IProps {
    history: any,
    classes: any,
    onUserLogout: any,
    onLogoutButtonClick: any
}

interface IState {
    email: string;
    isLoading: boolean;
    userDashboard: UserDashboardModel;
    isVisibleConfirmDialog: boolean;
}

const GET_DATA = `
    query GetData {
        userDashboard {
            user{
              email
              name
            }
            myMedicine{
              allMedicinesCount
              activeMedicinesCount
            }
            myDisease{
              allDiseasesCount
              activeDiseasesCount
            }
            myPrescription{
              allPrescriptionsCount
              activePrescriptionsCount
            }
            myFamily{
              allMemebersCount
            }
            myCondition{
              allConditionsCount
            }
            myLabResult{
              allLabResultsCount
            }
        }
    }
`

class UserDashboardComoponent extends React.Component<IProps, IState> {
    authService = new AuthService();
    growl: any;
    grapqlSerice = new GraphQLService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            email: '',
            userDashboard: new UserDashboardModel(),
            isLoading: false,
            isVisibleConfirmDialog: false
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.setState({ isLoading: true })
        this.grapqlSerice.getData(GET_DATA)
            .then((data: any) => {
                this.setState({
                    userDashboard: data.data.userDashboard,
                    isLoading: false
                });
            })
            .catch(error => {
                this.growl.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleMenuItemClick = (menuUrl, e?) => {
        if (e) {
            e.preventDefault();
        }
        this.props.history.push(menuUrl);
    }

    handleLogout = (e) => {
        e.preventDefault();

        this.setState({
            isVisibleConfirmDialog: true
        });
    }

    logoutConfirmClick = () => {
        this.authService.logout();
        this.props.onUserLogout();
        this.props.history.push('/');
        this.setState({
            isVisibleConfirmDialog: false
        })
    }

    render() {
        const { userDashboard, isLoading } = this.state;

        return (
            <>
                <div className="app-content" style={{ paddingBottom: 210, textAlign: "center" }}>
                    {isLoading ? <Spinner /> : null}
                    <Growl ref={(el) => this.growl = el} />
                    <h1>{userDashboard && userDashboard.user ? userDashboard.user.name : null}</h1>
                    {!isLoading ?
                        <>
                            <div>{userDashboard && userDashboard.user ? userDashboard.user.email : null}</div>
                            <div style={{ marginTop: 10, marginBottom: 20 }}>
                                <a href="" onClick={(e) => this.handleMenuItemClick('/user/profile', e)}>{Translate("Profile")}</a>{" | "}
                                <a href="" onClick={(e) => this.handleLogout(e)}>{Translate("Logout")}</a>
                            </div>
                            <div className="user-dashboard">
                                <div className="wrapper">
                                    <div className="container">
                                        <div className="item" onClick={() => this.handleMenuItemClick('/user/medicines')}>
                                            <div className="icon">
                                                <FontAwesomeIcon icon={faPills} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                                            </div>
                                            <div className="desc-number">
                                                <div className="desc">
                                                    {Translate('My Medicines')}
                                                </div>

                                                <div className="number">
                                                    <div className="content">
                                                        {userDashboard && userDashboard.myMedicine ? userDashboard.myMedicine.activeMedicinesCount + " / " : null}
                                                        {userDashboard && userDashboard.myMedicine ? userDashboard.myMedicine.allMedicinesCount : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="container">
                                        <div className="item" onClick={() => this.handleMenuItemClick('/user/diseases')}>
                                            <div className="icon">
                                                <FontAwesomeIcon icon={faStethoscope} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                                            </div>
                                            <div className="desc-number">
                                                <div className="desc">
                                                    {Translate('My Diseases')}
                                                </div>

                                                <div className="number">
                                                    <div className="content">
                                                        {userDashboard && userDashboard.myDisease ? userDashboard.myDisease.activeDiseasesCount + " / " : null}
                                                        {userDashboard && userDashboard.myDisease ? userDashboard.myDisease.allDiseasesCount : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrapper">
                                    <div className="container">
                                        <div className="item" onClick={() => this.handleMenuItemClick('/user/prescriptions')}>
                                            <div className="icon">
                                                <FontAwesomeIcon icon={faPrescription} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                                            </div>
                                            <div className="desc-number">
                                                <div className="desc">
                                                    {Translate('Doctors prescriptions')}
                                                </div>
                                                <div className="number">
                                                    <div className="content">
                                                        {userDashboard && userDashboard.myPrescription ? userDashboard.myPrescription.activePrescriptionsCount + " / " : null}
                                                        {userDashboard && userDashboard.myPrescription ? userDashboard.myPrescription.allPrescriptionsCount : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="container">
                                        <div className="item" onClick={() => this.handleMenuItemClick('/user/condition')}>
                                            <div className="icon">
                                                <FontAwesomeIcon icon={faHeartbeat} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                                            </div>
                                            <div className="desc-number">
                                                <div className="desc">
                                                    {Translate('My Condition')}
                                                </div>
                                                <div className="number">
                                                    <div className="content">
                                                        {userDashboard && userDashboard.myCondition ? userDashboard.myCondition.allConditionsCount : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrapper">
                                    <div className="container">
                                        <div className="item" onClick={() => this.handleMenuItemClick('/user/family')}>
                                            <div className="icon">
                                                <FontAwesomeIcon icon={faUsers} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                                            </div>
                                            <div className="desc-number">
                                                <div className="desc">
                                                    {Translate('My Family')}
                                                </div>
                                                <div className="number">
                                                    <div className="content">
                                                        {userDashboard && userDashboard.myFamily ? userDashboard.myFamily.allMemebersCount : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="container">
                                        <div className="item" onClick={() => this.handleMenuItemClick('/user/labresults')}>
                                            <div className="icon">
                                                <FontAwesomeIcon icon={faVial} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                                            </div>
                                            <div className="desc-number">
                                                <div className="desc">
                                                    {Translate('Laboratory result')}
                                                </div>
                                                <div className="number">
                                                    <div className="content">
                                                        {userDashboard && userDashboard.myLabResult ? userDashboard.myLabResult.allLabResultsCount : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        : null}
                </div>

                {this.state.isVisibleConfirmDialog ?
                    <ConfirmDialog
                        headerTitle={Translate("Logout")}
                        isVisible={this.state.isVisibleConfirmDialog}
                        yesClick={() => { this.logoutConfirmClick() }}
                        noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                        {Translate("Are you sure you want to logout")}
                    </ConfirmDialog>
                    : null}

            </>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT })
    }
}


export default connect(null, mapDispatchToProps)(UserDashboardComoponent);